// web/src/components/Divider.tsx
// Editorial section divider — hairline rule with an optional small-caps
// label centred over it. Used between major content blocks where Section's
// vertical rhythm alone isn't enough punctuation.

import type { CSSProperties } from 'react';

export interface DividerProps {
  /** Optional label centred on the line. */
  label?: string;
  style?: CSSProperties;
}

export function Divider({ label, style }: DividerProps) {
  if (!label) {
    return (
      <hr
        style={{
          border: 0,
          height: 1,
          background: 'var(--divider)',
          margin: 'var(--space-xl) 0',
          ...style,
        }}
      />
    );
  }
  return (
    <div
      role="separator"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--space-base)',
        margin: 'var(--space-xl) 0',
        ...style,
      }}
    >
      <span style={{ flex: 1, height: 1, background: 'var(--divider)' }} aria-hidden />
      <span
        style={{
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--micro)',
          letterSpacing: '0.22em',
          textTransform: 'uppercase',
          color: 'var(--muted)',
          whiteSpace: 'nowrap',
        }}
      >
        {label}
      </span>
      <span style={{ flex: 1, height: 1, background: 'var(--divider)' }} aria-hidden />
    </div>
  );
}
